import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    items: [
        // {
        //     link: 'users',
        //     title: 'title1'
        // },
        // {
        //     link: 'settings',
        //     title: 'title3'
        // }
    ],
}

export const breadcrumbsSlice = createSlice({
    name: 'breadcrumbs',
    initialState,
    reducers: {
        setBreadcrumbs: (state, action) => {
            state.items = action.payload
        },
        clearBreadcrumbs: (state) => {
            state.items = []
        },

    },
})

export const { setBreadcrumbs, clearBreadcrumbs } = breadcrumbsSlice.actions

export default breadcrumbsSlice.reducer